import http from "../../../../../core/utils/apis/skillApi";

const getSkillsRequests = async (options) => {
  try {
    const response = await http({
      method: "GET",
      url: "/skill-requests",
      params: options,
    });
    console.log("API Response:", response.data); 
    return response.data;
  } catch (e) {
    console.error("❌ Error fetching skill requests:", e);
    throw e;
  }
};


const approveSkillRequest = async (requestId, validatedBy) => {
  try {
    const response = await http({
      method: "PATCH",
      url: `/skill-requests/${requestId}/approve`,
      data: { validatedBy }, 
    });
    console.log("✅ Skill Request Approved:", response.data);
    return response.data;
  } catch (e) {
    console.error(`❌ Error approving skill request ${requestId}:`, e);
    throw e;
  }
};

const rejectSkillRequest = async (requestId, approverId) => {
  try {
    const response = await http({
      method: "PATCH",
      url: `/skill-requests/${requestId}/reject`,
      data: { approverId },
    });
    console.log("❌ Skill Request Rejected:", response.data);
    return response.data;
  } catch (e) {
    console.error(`❌ Error rejecting skill request ${requestId}:`, e);
    throw e;
  }
};

const TeamSkillValidationService = {
  getSkillsRequests,
  approveSkillRequest,
  rejectSkillRequest,

};

export default TeamSkillValidationService;
